var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8333 4.00075C7.83361 4.06645 7.8208 4.13154 7.79561 4.19221C7.77042 4.25289 7.73337 4.30792 7.68663 4.35409L4.03997 8.00075L7.68663 11.6474C7.77495 11.7422 7.82304 11.8676 7.82075 11.9971C7.81847 12.1266 7.76599 12.2502 7.67438 12.3418C7.58277 12.4334 7.45918 12.4859 7.32965 12.4882C7.20011 12.4905 7.07475 12.4424 6.97997 12.3541L2.97997 8.35409C2.88633 8.26034 2.83374 8.13325 2.83374 8.00075C2.83374 7.86825 2.88633 7.74117 2.97997 7.64742L6.97997 3.64742C7.07372 3.55379 7.2008 3.50119 7.3333 3.50119C7.4658 3.50119 7.59288 3.55379 7.68663 3.64742C7.73337 3.69358 7.77042 3.74862 7.79561 3.80929C7.8208 3.86997 7.83361 3.93506 7.8333 4.00075Z",
    fill: "#16304F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1667 8C13.165 8.13207 13.1117 8.25825 13.0184 8.35164C12.925 8.44504 12.7988 8.49827 12.6667 8.5L3.33337 8.5C3.20077 8.5 3.07359 8.44732 2.97982 8.35355C2.88605 8.25978 2.83337 8.13261 2.83337 8C2.83337 7.86739 2.88605 7.74022 2.97982 7.64645C3.07359 7.55268 3.20077 7.5 3.33337 7.5L12.6667 7.5C12.7988 7.50173 12.925 7.55496 13.0184 7.64836C13.1117 7.74175 13.165 7.86793 13.1667 8Z",
    fill: "#16304F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.16908024699043c8167807ebe5929cd9.svg";
export { ForwardRef as ReactComponent };